import { render, staticRenderFns } from "./PreviewOrderDetails.vue?vue&type=template&id=4744d2af"
import script from "./PreviewOrderDetails.vue?vue&type=script&lang=js"
export * from "./PreviewOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports